/**
 * Dev bypass for subscription gates.
 * Set BYPASS_SUBSCRIPTION_GATES=true in .env.local to bypass all subscription checks.
 *
 * Lives in its own file (with no DB imports) so client-bundled code that only
 * needs this check can import it without dragging Prisma into the client.
 */
export function isSubscriptionBypassed(): boolean {
  return process.env.BYPASS_SUBSCRIPTION_GATES === "true";
}
